import { useParams } from 'react-router-dom';
/**
 * A hook that lets you work with the path params associated with an app path.
 * Reading path params should in turn be done through this hook as it
 * facilitates complete type-safety.
 */
export const useAppPathParams = (_path) => {
    const params = useParams();
    return params;
};
